import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";

import { useAuth } from "context/AuthContext";
import { useLoading } from "context/LoadingContext";
import { useNotification } from "context/NotificationContext";

import Api from "utils/Api";
import TrataRetornoApi from "utils/TrataRetornoApi";

const ListarPainelIndicadores = () => {
  const { setLoading } = useLoading();
  const notificacao = useNotification();
  const auth = useAuth();
  const requisicao = new Api();
  const tratarRetornoApi = new TrataRetornoApi();

  const jaExecutouRef = useRef(false);

  // estados
  const [dadosNotasPendentes, setDadosNotasPendentes] = useState([]);
  const [totalNotasPendentes, setTotalNotasPendentes] = useState(0);
  const [ehOperador, setEhOperador] = useState(true);
  const [dadosUltimoSincronismo, setDadosUltimoSincronismo] = useState([]);
  const [dadosUltimoSincronismoFiltrados, setDadosUltimoSincronismoFiltrados] = useState([]);
  const [modalDetalhes, setModalDetalhes] = useState(false);
  const [detalhesVenda, setDetalhesVenda] = useState([]);
  const [semSerie, setSemSerie] = useState({
    semSerieNfeEntrada: [],
    semSerieNfeSaida: [],
    semSerieNfeEntradaSaida: []
  });
  const [filiaisSemNumeroSerieNfce, setFiliaisSemNumeroSerieNfce] = useState(
    []
  );
  const [qtdeErroLogErroInterno, setQtdeErroLogErroInterno] = useState(0);
  const [qtdeUsuariosSenhasDuplicados, setQtdeUsuariosSenhasDuplicados] =
    useState(0);

  // toggles
  const [showPendentes, setShowPendentes] = useState(false);
  const [showSincronismo, setShowSincronismo] = useState(false);
  const [showEntrada, setShowEntrada] = useState(false);
  const [showSaida, setShowSaida] = useState(false);
  const [showEntradaSaida, setShowEntradaSaida] = useState(false);
  const [showSemSerieNfce, setShowSemSerieNfce] = useState(false);

  // filtro de sincronização
  const [filtroSincronismo, setFiltroSincronismo] = useState("todos");

  // opções do filtro de sincronização
  const opcoesFiltroSincronismo = [
    { label: "Todos", value: "todos" },
    { label: "Não sincronizados há mais de 1 dia", value: "1d" },
    { label: "Não sincronizados há mais de 3 dias", value: "3d" },
    { label: "Não sincronizados há mais de 1 mês", value: "1m" },
    { label: "Nunca sincronizados", value: "nunca" }
  ];

  // colunas das tabelas
  const colunasNotasPendentes = [
    { field: "operadorNome", header: "Operador" },
    { field: "lojaCodigo", header: "Loja" },
    { field: "balcaoNome", header: "Nome do Balcão" },
    { field: "balcaoCnpj", header: "CNPJ do Balcão" },
    { field: "quantidade", header: "Qtde" }
  ];
  const colunasUltimoSincronismo = [
    { field: "operadorNome", header: "Operador" },
    { field: "lojaCodigo", header: "Loja" },
    { field: "balcaoNome", header: "Nome do Balcão" },
    { field: "balcaoCnpj", header: "CNPJ do Balcão" },
    { field: "ultimaSincronizacao", header: "Última Sincronização" }
  ];


  const colunasSemSerie = [
    { field: "operador", header: "Operador" },
    { field: "cnpjBalcao", header: "CNPJ do Balcão" }
  ];
  const colunasFiliaisSemSerie = [
    { field: "cnpj", header: "CNPJ" },
    { field: "lojaId", header: "Loja ID" },
    { field: "balcaoId", header: "Balcão ID" }
  ];

  // helpers de estilo
  const getNumericColor = (value) => (value > 0 ? "red" : "green");
  const getBorderStyle = (value) => `2px solid ${value > 0 ? "red" : "green"}`;

  const baseCardStyle = {
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    marginBottom: "1rem"
  };

  const formatarData = (dateString) =>
    dateString ? new Date(dateString).toLocaleString("pt-BR") : "";

  // Função para extrair data do texto formatado
  const extrairDataDoTexto = (textoFormatado) => {
    if (!textoFormatado || 
        textoFormatado === "null" || 
        textoFormatado === "undefined" ||
        textoFormatado.includes("Nenhuma sincronização")) {
      return null;
    }
    
    // Tenta extrair a data do formato "18/08/2025 11:03 (há 1 dia, 7 horas e 48 minutos)"
    const match = textoFormatado.match(/(\d{2}\/\d{2}\/\d{4} \d{2}:\d{2})/);
    if (match) {
      const dataStr = match[1];
      // Converte "18/08/2025 11:03" para Date
      const [data, hora] = dataStr.split(' ');
      const [dia, mes, ano] = data.split('/');
      const [h, min] = hora.split(':');
      
      // Cria a data (mes - 1 porque Date usa 0-11 para meses)
      const dataExtraida = new Date(ano, mes - 1, dia, h, min);
      console.log(`📅 Extraindo data de "${textoFormatado}" → ${dataExtraida.toISOString()}`);
      return dataExtraida;
    }
    
    // Se não conseguir extrair, tenta criar Date diretamente
    try {
      const dataExtraida = new Date(textoFormatado);
      console.log(`📅 Data direta de "${textoFormatado}" → ${dataExtraida.toISOString()}`);
      return dataExtraida;
    } catch (e) {
      console.warn("❌ Não foi possível extrair data de:", textoFormatado);
      return null;
    }
  };

  // Função para filtrar dados de sincronização
  const filtrarDadosSincronismo = (dados, filtro) => {
    console.log("🔍 Filtrando dados:", { totalDados: dados.length, filtro });
    
    if (filtro === "todos") {
      console.log("✅ Retornando todos os dados");
      return dados;
    }

    const agora = new Date();
    console.log("📅 Data atual:", agora.toISOString());
    
    const dadosFiltrados = dados.filter(item => {
      // Extrai a data do texto formatado
      const dataSincronizacao = extrairDataDoTexto(item.ultimaSincronizacao);
      
      // Verifica se não há sincronização ou se é inválida
      if (!dataSincronizacao || Number.isNaN(dataSincronizacao.getTime())) {
        const resultado = filtro === "nunca";
        console.log(`🔄 Item sem sincronização: ${item.operadorNome || item.lojaCodigo} - Filtro "nunca": ${resultado}`);
        return resultado;
      }
      
      const diferencaHoras = (agora - dataSincronizacao) / (1000 * 60 * 60);
      const diferencaDias = diferencaHoras / 24;

      let resultado = false;
      switch (filtro) {
        case "1d":
          resultado = diferencaDias > 1;
          break;
        case "3d":
          resultado = diferencaDias > 3;
          break;
        case "1m":
          resultado = diferencaDias > 30;
          break;
        case "nunca":
          resultado = false; // Nunca sincronizados já foi tratado acima
          break;
        default:
          resultado = true;
      }
      
             console.log(`📊 Item: ${item.operadorNome || item.lojaCodigo} | Última sinc: ${dataSincronizacao.toISOString()} | Dif: ${diferencaDias.toFixed(1)}d | Filtro "${filtro}": ${resultado}`);
      
      return resultado;
    });
    
    console.log(`✅ Filtro aplicado: ${dadosFiltrados.length} de ${dados.length} itens`);
    return dadosFiltrados;
  };

  // Função para ordenar dados de sincronização
  const ordenarDadosSincronismo = (dados) => {
    console.log("📊 Ordenando dados de sincronização...");
    
    return [...dados].sort((a, b) => {
      // Extrai as datas do texto formatado
      const dataA = extrairDataDoTexto(a.ultimaSincronizacao);
      const dataB = extrairDataDoTexto(b.ultimaSincronizacao);
      
      // Verifica se A não tem sincronização
      const aSemSincronizacao = !dataA || Number.isNaN(dataA.getTime());
      
      // Verifica se B não tem sincronização
      const bSemSincronizacao = !dataB || Number.isNaN(dataB.getTime());
      
      // Se ambos não têm sincronização, mantém ordem original
      if (aSemSincronizacao && bSemSincronizacao) {
        return 0;
      }
      
      // Se apenas A não tem sincronização, A vem primeiro
      if (aSemSincronizacao && !bSemSincronizacao) {
        return -1;
      }
      
      // Se apenas B não tem sincronização, B vem primeiro
      if (!aSemSincronizacao && bSemSincronizacao) {
        return 1;
      }
      
      // Se ambos têm sincronização, ordena por data decrescente (mais recente primeiro)
      console.log(`🔍 Comparando: ${a.operadorNome} (${dataA.toISOString()}) vs ${b.operadorNome} (${dataB.toISOString()})`);
      
      return dataB - dataA;
    });
  };

  // Efeito para aplicar filtro quando mudar
  useEffect(() => {
    console.log("🔄 useEffect - Aplicando filtro:", { filtroSincronismo, totalDados: dadosUltimoSincronismo.length });
    const dadosFiltrados = filtrarDadosSincronismo(dadosUltimoSincronismo, filtroSincronismo);
    const dadosOrdenados = ordenarDadosSincronismo(dadosFiltrados);
    
    console.log("📋 Resultado da ordenação:");
    dadosOrdenados.slice(0, 5).forEach((item, index) => {
      console.log(`${index + 1}. ${item.operadorNome} - ${item.ultimaSincronizacao}`);
    });
    
    setDadosUltimoSincronismoFiltrados(dadosOrdenados);
  }, [filtroSincronismo, dadosUltimoSincronismo]);

  const carregarIndicadores = async () => {
    try {
      setLoading(true);
      const resposta = await requisicao.Get({
        endpoint: "/PainelIndicadores/Simplificado",
        config: auth.GetHeaders()
      });

      if (resposta?.codigoEstadoHttp === 200) {
        const notas = resposta.objetoResposta.notasPendenteEmissaoPorLoja || [];
        setDadosNotasPendentes(notas);
        setTotalNotasPendentes(
          notas.reduce((soma, item) => soma + (item.quantidade || 0), 0)
        );
                 const dadosSincronismo = resposta.objetoResposta.ultimosLogsSincronismoPorLoja || [];
         const dadosOrdenados = ordenarDadosSincronismo(dadosSincronismo);
         
         console.log("📋 Dados iniciais ordenados:");
         dadosOrdenados.slice(0, 5).forEach((item, index) => {
           console.log(`${index + 1}. ${item.operadorNome} - ${item.ultimaSincronizacao}`);
         });
         
         setDadosUltimoSincronismo(dadosOrdenados);

        const devol =
          resposta.objetoResposta?.cnpjsBalcoesSemSerieNfeDevolucao || {};

        setSemSerie({
          semSerieNfeEntrada: devol.semSerieNfeEntrada || [],
          semSerieNfeSaida: devol.semSerieNfeSaida || [],
          semSerieNfeEntradaSaida: devol.semSerieNfeEntradaSaida || []
        });
        setFiliaisSemNumeroSerieNfce(
          resposta.objetoResposta?.filiaisSemNumeroSerieNfce || []
        );
        setQtdeErroLogErroInterno(
          resposta.objetoResposta?.qtdeErroLogErroInterno || 0
        );
        setQtdeUsuariosSenhasDuplicados(
          resposta.objetoResposta?.qtdeUsuariosSenhasDuplicados || 0
        );

        const ehOperadorAux = resposta.objetoResposta?.ehOperador;

        console.log("ehOperadorAux", ehOperadorAux);

        setEhOperador(ehOperadorAux);
      } else {
        notificacao({
          type: "erro",
          message: tratarRetornoApi.obterMensagemErro(resposta)
        });
      }
    } catch (error) {
      notificacao({
        type: "erro",
        message: tratarRetornoApi.obterMensagemErro(error)
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!jaExecutouRef.current) {
      jaExecutouRef.current = true;
      carregarIndicadores();
    }
  }, []);

  const abrirModalDetalhes = (vendasPendentes) => {
    setDetalhesVenda(vendasPendentes || []);
    setModalDetalhes(true);
  };

  const exibirDetalhesTemplate = (rowData) => (
    <Button
      icon="pi pi-search"
      className="p-button-text"
      onClick={() => abrirModalDetalhes(rowData.vendasComNotasPendentes)}
      disabled={!rowData.vendasComNotasPendentes?.length}
    />
  );

  return (
    <div className="p-grid">
      {/* Notas Pendentes */}
      <div className="p-col-12">
        <Card
          style={{
            ...baseCardStyle,
            border: getBorderStyle(totalNotasPendentes)
          }}
        >
          <div
            role="button"
            tabIndex={0}
            onClick={() => setShowPendentes((v) => !v)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setShowPendentes((v) => !v);
              }
            }}
            style={{
              textAlign: "center",
              cursor: "pointer",
              padding: "1.5rem"
            }}
          >
            <h3 style={{ fontWeight: 600 }}>
              Notas Fiscais Pendentes de Emissão
            </h3>
            <p
              style={{
                fontSize: "2rem",
                margin: 0,
                fontWeight: 700,
                color: getNumericColor(totalNotasPendentes)
              }}
            >
              {totalNotasPendentes}
              <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                {" "}
                notas pendentes
              </span>
            </p>
            <p style={{ fontSize: "1rem", marginTop: "0.3rem", color: "#666" }}>
              em {dadosNotasPendentes.length} balcões
            </p>
          </div>
          {showPendentes && (
            <div
              style={{
                padding: "1rem",
                backgroundColor: "#f9f9f9",
                borderTop: "1px solid #eee",
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px"
              }}
            >
              <DataTable
                value={dadosNotasPendentes}
                paginator
                rows={10}
                tableStyle={{ minWidth: "60rem" }}
                emptyMessage="Nenhum dado encontrado."
              >
                {colunasNotasPendentes.map((col) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    sortable
                  />
                ))}
                <Column
                  header="Ações"
                  body={exibirDetalhesTemplate}
                  style={{ textAlign: "center" }}
                />
              </DataTable>
            </div>
          )}
        </Card>
      </div>

      {!ehOperador && (
        <>
          {/* Sincronismo */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(dadosUltimoSincronismoFiltrados.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowSincronismo((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowSincronismo((v) => !v);
                  }
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>Último Sincronismo</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: "#000"
                  }}
                >
                  {dadosUltimoSincronismoFiltrados.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões (total de lojas)
                  </span>
                </p>
                <p style={{ fontSize: "0.9rem", marginTop: "0.3rem", color: "#666" }}>
                  {opcoesFiltroSincronismo.find(op => op.value === filtroSincronismo)?.label}
                </p>
              </div>
              {showSincronismo && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  {/* Filtro de sincronização */}
                  <div style={{ marginBottom: "1rem" }}>
                    <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 600 }}>
                      Filtrar por período:
                    </label>
                                                               <Dropdown
                        value={filtroSincronismo}
                        options={opcoesFiltroSincronismo}
                        onChange={(e) => {
                          console.log("🎯 Dropdown onChange:", e.value);
                          setFiltroSincronismo(e.value);
                        }}
                        placeholder="Selecione um filtro"
                        style={{ width: "400px" }}
                      />
                  </div>
                  
                  <DataTable
                    value={dadosUltimoSincronismoFiltrados}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "60rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasUltimoSincronismo.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                                                 body={col.field === "ultimaSincronizacao" ? (rowData) => 
                           rowData.ultimaSincronizacao || "Não sincronizado (ou sistema inferior à versão 1.7.8)"
                         : undefined}
                      />
                    ))}
                    
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* Balcões sem Série NFCe */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(filiaisSemNumeroSerieNfce.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowSemSerieNfce((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowSemSerieNfce((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>Balcões sem Série NFCe</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(filiaisSemNumeroSerieNfce.length)
                  }}
                >
                  {filiaisSemNumeroSerieNfce.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showSemSerieNfce && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={filiaisSemNumeroSerieNfce}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasFiliaisSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* CNPJs sem Série Entrada e Saída */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(semSerie.semSerieNfeEntradaSaida.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowEntradaSaida((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowEntradaSaida((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>
                  CNPJs sem Série Entrada e Saída
                </h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(
                      semSerie.semSerieNfeEntradaSaida.length
                    )
                  }}
                >
                  {semSerie.semSerieNfeEntradaSaida.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showEntradaSaida && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={semSerie.semSerieNfeEntradaSaida}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* CNPJs sem Série NFe Entrada */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(semSerie.semSerieNfeEntrada.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowEntrada((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowEntrada((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>CNPJs sem Série NFe Entrada</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(semSerie.semSerieNfeEntrada.length)
                  }}
                >
                  {semSerie.semSerieNfeEntrada.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showEntrada && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={semSerie.semSerieNfeEntrada}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* CNPJs sem Série NFe Saída */}
          <div className="p-col-12">
            <Card
              style={{
                ...baseCardStyle,
                border: getBorderStyle(semSerie.semSerieNfeSaida.length)
              }}
            >
              <div
                role="button"
                tabIndex={0}
                onClick={() => setShowSaida((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ")
                    setShowSaida((v) => !v);
                }}
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "1.5rem"
                }}
              >
                <h3 style={{ fontWeight: 600 }}>CNPJs sem Série NFe Saída</h3>
                <p
                  style={{
                    fontSize: "2rem",
                    margin: 0,
                    fontWeight: 700,
                    color: getNumericColor(semSerie.semSerieNfeSaida.length)
                  }}
                >
                  {semSerie.semSerieNfeSaida.length}
                  <span style={{ fontSize: "1rem", fontWeight: 400 }}>
                    {" "}
                    balcões
                  </span>
                </p>
              </div>
              {showSaida && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f9f9f9",
                    borderTop: "1px solid #eee",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px"
                  }}
                >
                  <DataTable
                    value={semSerie.semSerieNfeSaida}
                    paginator
                    rows={10}
                    tableStyle={{ minWidth: "40rem" }}
                    emptyMessage="Nenhum dado encontrado."
                  >
                    {colunasSemSerie.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                      />
                    ))}
                  </DataTable>
                </div>
              )}
            </Card>
          </div>

          {/* Log Erros Internos */}
          <div className="p-col-12 p-md-6">
            <Card
              style={{
                ...baseCardStyle,
                textAlign: "center",
                padding: "1rem",
                border: getBorderStyle(qtdeErroLogErroInterno)
              }}
            >
              <h3 style={{ fontWeight: 600 }}>Log de Erros Internos</h3>
              <p
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: getNumericColor(qtdeErroLogErroInterno)
                }}
              >
                {qtdeErroLogErroInterno}
              </p>
            </Card>
          </div>

          {/* Usuários com Senha Duplicada */}
          <div className="p-col-12 p-md-6">
            <Card
              style={{
                ...baseCardStyle,
                textAlign: "center",
                padding: "1rem",
                border: getBorderStyle(qtdeUsuariosSenhasDuplicados)
              }}
            >
              <h3 style={{ fontWeight: 600 }}>Usuários com Senha Duplicada</h3>
              <p
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: getNumericColor(qtdeUsuariosSenhasDuplicados)
                }}
              >
                {qtdeUsuariosSenhasDuplicados}
              </p>
            </Card>
          </div>
        </>
      )}

      {/* Modal de detalhes */}
      <Dialog
        header="Vendas com Notas Pendentes"
        visible={modalDetalhes}
        style={{ width: "40vw" }}
        onHide={() => setModalDetalhes(false)}
      >
        {detalhesVenda.length > 0 ? (
          <ul>
            {detalhesVenda.map((v) => (
              <li key={v.id}>
                <strong>Venda:</strong> {v.numero} <br />
                <strong>Data:</strong> {formatarData(v.dataVenda)}
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhuma venda encontrada.</p>
        )}
      </Dialog>
    </div>
  );
};

export default ListarPainelIndicadores;
